
export default function officeTabs () {

	const tabs = document.querySelectorAll('section.offices button');

	if (! tabs.length) return;



	const selectElement = document.querySelector('section.offices select');

	// Helper to update select based on tab
	function updateSelectForTab(tabId) {
		if (selectElement) {
			const officeId = tabId.substring('office-tab-'.length);
			selectElement.value = officeId;
		}
	}
 
	// Init - use delay (can't detect Flowbite init)
	setTimeout(() => {
 
		const hash = window.location.hash.slice(1);
		if (hash) {
 
			const tab = document.querySelector(`#office-tab-${hash}`);
			if (tab) {
				tab.click();
				updateSelectForTab(tab.id);
			}
 
			const section = tab.closest('section');
			section.scrollIntoView({
				block: 'start',
				behavior: 'smooth',
			});
 
		}
 
		let byUser = true;
 
		// When select changes, click the corresponding tab
		if (selectElement) {
			selectElement.addEventListener('change', function() {
				const selectedValue = this.value;
				const tab = document.querySelector(`#office-tab-${selectedValue}`);
				if (tab) {
					byUser = true; // Mark as user action so hash gets updated
					tab.click();
				}
			});
		}
 
		// Anchor update on tab click
		tabs.forEach(tab => {
 
			tab.addEventListener('click', function () {
 
				// Update select to match active tab
				updateSelectForTab(this.id);
 
				if (byUser) {
					// Extract the part after 'office-tab-'
					const officeId = this.id.substring('office-tab-'.length);
 
					// Update the URL anchor and add to history
					const newUrl = `${window.location.pathname}#${officeId}`;
					history.pushState(null, '', newUrl);
				}
 
				byUser = true;
 
			});
 
		});
 
		// Tab switch on hash change
		window.addEventListener('hashchange', function() {

			const hash = window.location.hash.slice(1);
			if (hash) {

				const tab = document.querySelector(`#office-tab-${hash}`);
				if (tab) {

					byUser = false;
					tab.click();

				}

			}

		});

	}, 300);

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too (the actual tab-panel switching is Flowbite's
	own data-tabs-toggle behaviour, re-armed generically in blocks.js).
	ACF's block-preview JS runs in the outer admin window, while this script
	runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=offices', officeTabs);
}
